export const CREDENTIAL_SUPERSEDED_CODE = "AUTH_SESSION_SUPERSEDED";

// Prefer randomUUID, then build a v4 UUID with the secure random source available in older browsers.
export function newTurnId() {
  const crypto = window.crypto;
  if (typeof crypto?.randomUUID === "function") {
    try {
      return crypto.randomUUID();
    } catch {
      // Fall through to getRandomValues.
    }
  }
  if (typeof crypto?.getRandomValues !== "function") return null;
  try {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  } catch (error) {
    return null;
  }
}

export function isUnavailableError(error) {
  const status = error && (error.status || error.statusCode || error.response?.status);
  return status === 401 || status === 403;
}

export function isCredentialSupersededError(error) {
  return errorDetails(error).code === CREDENTIAL_SUPERSEDED_CODE;
}

export function canSendTurn(state, input) {
  return Boolean(input && input.trim()) && Boolean(state.session) && !state.isSending && !state.isOpening && !state.unavailable && !state.credentialSuperseded;
}

const REQUEST_THROTTLE_CODES = new Set(["AI_RATE_LIMITED", "AI_REQUEST_IN_PROGRESS"]);

export function isAssistantRequestThrottle(error) {
  const details = errorDetails(error);
  return details.status === 429 && REQUEST_THROTTLE_CODES.has(details.code);
}

export function errorDetails(error) {
  const body = error && (error.error || error.response?.data?.error || error);
  const status = error && (error.status || error.statusCode || error.response?.status);
  const details = { code: body?.code || "SERVICE_UNAVAILABLE", correlationRef: body?.correlationRef || null, ...(typeof status === "number" ? { status } : {}) };
  if (status === 429 && REQUEST_THROTTLE_CODES.has(details.code)) {
    const seconds = body?.retryAfterSeconds;
    details.retryAfterSeconds = Number.isSafeInteger(seconds) && seconds > 0 && seconds <= 86400 ? seconds : 2;
  }
  return details;
}
